import { Header } from '../../Table';
import {
  expandData,
  expandHeaders,
  formatValueForExport,
  reconstructOriginalHeaders,
} from './exportUtils';

export const exportToCsv = (
  data: { [key: string]: any }[],
  headers: Header[],
  fileName: string = `${new Date().toDateString()}.csv`,
  delimeter: string = ',',
) => {
  // Verificar si los headers ya están expandidos
  const areHeadersExpanded = headers.some(
    (h) =>
      h.key.includes('_primary') ||
      h.key.includes('_secondary') ||
      h.key.includes('_amount') ||
      h.key.includes('_date'),
  );

  let expandedHeaders: Header[];
  let expandedData: any[];

  if (areHeadersExpanded) {
    // Los headers ya están expandidos, usarlos directamente
    expandedHeaders = headers;
    // Reconstruir headers originales para expandir los datos correctamente
    const originalHeaders = reconstructOriginalHeaders(headers);
    expandedData = expandData(data, originalHeaders);
  } else {
    // Expandir headers para tipos especiales
    expandedHeaders = expandHeaders(headers);
    // Expandir datos según los headers expandidos
    expandedData = expandData(data, headers);
  }

  const headersLabels = expandedHeaders.map((header) => header.label);
  let parsedData: any = headersLabels.join(delimeter) + '\n';

  for (const row of expandedData) {
    const rowValues = expandedHeaders.map((header) => {
      const value = row[header.key];
      return formatValueForExport(value, header.type);
    });
    parsedData += rowValues.join(delimeter) + '\n';
  }

  const csvContent = `data:text/csv;charset=utf-8,${parsedData}`;
  const encodedURI = encodeURI(csvContent);

  const a = document.createElement('a');
  a.href = encodedURI;
  a.download = fileName;
  a.click();
};
